<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">User Management</a></li> -->
              <!-- <li class="breadcrumb-item active">User Management</li> -->
            </ol>
          </div>
          <h4 class="page-title">User Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Users</h4>
          <p class="sub-header">
            Onboard new users for your current participant
          </p>

          <div class="row">
            <div class="col-12" *ngIf="canDoGlobalSearch">
              <table>
                <tr>
                  <th>Global Search &nbsp;</th>
                  <td>
                    <input type="checkbox" id="globalUser" placeholder="Activate Global user search" (change)="SetGlobalSearch($event)" />
                  </td>
                </tr>
              </table>
            </div>
            <div class="col-12" *ngIf="canAdd">
              <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="addNewUser()"> <i class="mdi mdi-account-multiple-plus-outline"></i> </button>
            </div>

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Active</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of users">
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td>
                      <i class="mdi mdi-check table-icon" *ngIf="!!user.isActive"></i>
                      <i class="mdi mdi-close table-icon" *ngIf="!user.isActive"></i>
                    </td>
                    <td>
                      <button *ngIf="canEdit" (click)="updateUser(user)" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        Edit
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> <!-- end container -->
</div>
